import type { Register } from "@tanstack/react-router";
import { unreachable } from "@warrenio/utils/unreachable";
import { atomWithLazy } from "jotai/utils";

export const routerAtom = atomWithLazy<Register["router"]>(() => unreachable("routerAtom not hydrated"));
